import script from "./DocumentacaoTelaCadastro.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentacaoTelaCadastro.vue?vue&type=script&setup=true&lang=js"

import "./DocumentacaoTelaCadastro.vue?vue&type=style&index=0&id=555a1180&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-555a1180"]])

export default __exports__